export type TRating = 'extra hot' | 'hot' | 'warm' | 'cold' | 'none';

export const EXTRA_HOT: TRating = 'extra hot';
export const HOT: TRating = 'hot';
export const WARM: TRating = 'warm';
export const COLD: TRating = 'cold';
export const NONE: TRating = 'none';

export const RATINGS = [EXTRA_HOT, HOT, WARM, COLD, NONE];

export const EXTRA_HOT_COLOR = '#6F6CC9';
export const HOT_COLOR = '#E16A6b';
export const WARM_COLOR = '#F2A94C';
export const COLD_COLOR = '#4BB5D7';
export const NONE_COLOR = '#A1AFB6';

export const RATING_COLORS = {
    [EXTRA_HOT]: EXTRA_HOT_COLOR,
    [HOT]: HOT_COLOR,
    [WARM]: WARM_COLOR,
    [COLD]: COLD_COLOR,
    [NONE]: NONE_COLOR,
};
